import { Flex } from 'antd';
import React from 'react';
import { useCommunitySettings } from '@guuru/community-web';
import { usePageTitle } from '@guuru/react-hooks';
import AboutCommunity from '../../components/Invitation/Content/AboutCommunity';
import BestGuurus from '../../components/Invitation/Content/BestGuurus';
import HowItWorks from '../../components/Invitation/Content/HowItWorks';
import HowToJoin from '../../components/Invitation/Content/HowToJoin';

const Invitation = function () {
  const { partnerName } = useCommunitySettings();
  usePageTitle(
    `Become a Trusted ${partnerName} Community Member | GUURU`,
    `Meet experienced members of the ${partnerName} community sharing product advice and real customer experience.`,
  );
  return (
    <Flex vertical gap={100}>
      <AboutCommunity />
      <HowItWorks />
      <HowToJoin />
      <BestGuurus />
    </Flex>
  );
};

export default Invitation;
